/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSecureToken} from '../api'

 export const useQueryGetSecureToken = createReactQueryHook('getSecureToken', getSecureToken)
